import { useState } from 'react';

export const usePagination = (initialState = { page: 1, size: 10 }) => {
    const [pagination, setPagination] = useState(initialState);

    const handlePrevious = () => {
        setPagination((options) => ({ ...options, page: options.page - 1 }));
    };

    const handleNext = () => {
        setPagination((options) => ({ ...options, page: options.page + 1 }));
    };

    const handlePage = (page) => {
        setPagination((options) => ({ ...options, page }));
    };

    const handleRefresh = () => {
        setPagination((options) => ({
            ...options,
            key: Math.random()
        }));
    };

    const handlers = {
        onPrevious: handlePrevious,
        onRefresh: handleRefresh,
        onNext: handleNext,
        onPage: handlePage
    };

    return {
        pagination,
        setPagination,
        handlers
    };
};
